// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  enable_ssr: false,
  beta: false,
  production: false,
  // API_ENDPOINT: 'https://api.yelo.red/',
  API_ENDPOINT: 'https://test-api-3022.jungleworks.com/',
  SOCKET_ENDPOINT: 'https://beta-socket.yelo.red/',
  API_ENDPOINT_TOOKAN: 'https://ipconfig.tookanapp.com/',
  dashboard_url: 'https://dev3.yelo.red/en/',
  maps_api_url: 'https://nominatim-api-live.jungleworks.com',
  //SSR
  // DIST: 'dist',
  // REDIS_PORT: 6379,
  // REDIS_HOST: '127.0.0.1',
  // SSR_PORT: 4000,
  // SSR_PORT: 4100, //for themes specifc at test
  // SSR_API_ENDPOINT:'https://test-api-3004.yelo.red/',
  SSR_Langs: ['en', 'fr', 'ar', 'es', 'ms', 'zh-Hans', 'pt', 'zh-Hant', 'bn', 'es-mx', 'km', 'ka', 'ro', 'ta', 'si', 'sv', 'nl', 'el', 'ko', 'pt-br', 'th', 'mr', 'hi', 'ru', 'ar-sa', 'it', 'hr', 'lv', 'tr','nb','lo','vi','fr-ch','hu','de', 'ar-kl', 'sk','kn','ku','he','ja','bs','mk', 'customLang1','customLang2','customLang3','customLang4','l1','l2','l3','l4'],
  jungle_payment_url: 'https://dev-payments.jungleworks.com/',
  hippo_Notp: 'https://api-graviton-multiple-fugu.hippochat.io:3002/api/',
  // TATA_ENDPOINT: 'https://api.tatadigital.com/api/v2/sso',
  TATA_ENDPOINT: 'https://ppapi.tatadigital.com/api/v2/sso',
  defaultMapprKey: '5e095000-d05c-11ec-a225-55c1449998e5'

};
